/**
 * Created by godshadow on 04/08/16.
 */

enum SetupType 
{
    Company,
    Settings,
    VAT,
    LegalTax,
    LegalTaxType,
    PayMethods,
    PaymentInstallmentTemplates,
    PayEntities,
    TimeRangePreset,
    Departments,
    Warehouse,
    Online,
    StockCustomConcept,
    Format,
    Tags,
    ProductSource,
    AttributeType,
    BookingsChannels,
    BookingsRecommendation,
    BookingsZones,
    BookingsZonesSetup,
    CommunicationTemplate,
    SerialSequence,
    AccountSequence,
    Licenses,
    ElaborationCenter,
    KitchenOrder,
    CustomConpcept,
    Changelog,
    LedgerAccount,
    LicenseType,
    QRLocationType,
    WineCellar,
    ProductAttributeType,
    StockCategory,
    ServiceStatus,
    BusinessReasonType,
    AnalyticAccount,
    EmployeeCompensationConcept,
    Integrators,
    IntegratorMapping,
    BankAccountMapping,
    AccountingJournalTemplate,
    TaxRegimeType,
    DocumentCategorization,
    ProductClassification,
    BusinessAreas,
    ScheduledReports,
    PaymentFeeTemplates
}
class SetupViewController extends BaseViewController
{
    static newInstance() : SetupViewController {
        let vc = new SetupViewController("setup-view");
        vc.initWithResource("layout/setup/SetupView.html");
        return vc;
    }

    private tableView:UITableView = null;

    private _current = {};
    private noDetailViewController = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.tableView = MUIOutlet(this,"table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;

        this.tableView.reloadData();
    }

    numberOfSections( tableview:UITableView ){
        return 1;
    }

    numberOfRowsInSection(tableview:UITableView, section:number){
        return this.items.length;
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier("SetupCell") as SetupCell;

        let s = this.items[indexPath.row];
        cell.title = s.name;

        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        this._current = this.items[indexPath.row];
        this._showCurrentItem();
    }

    private _showCurrentItem(){
        let sdvc = null;

        switch(this._current['type'])
        {
            case SetupType.Company        : sdvc = CompanyViewController.newInstance()        ; break;
            case SetupType.Settings       : sdvc = PlaceSettingsViewController.newInstance()  ; break;
            case SetupType.LicenseType    : sdvc = LicenseTypeViewController.newInstance()    ; break;
            case SetupType.BusinessReasonType: sdvc = BusinessReasonTypeViewController.newInstance(); break;
            case SetupType.TaxRegimeType : sdvc = TaxRegimeTypeViewController.newInstance() ; break;
            case SetupType.DocumentCategorization: sdvc = DocumentCategorizationViewController.newInstance(); break;
            case SetupType.ProductClassification: sdvc = ProductClassificationViewController.newInstance(); break;
            case SetupType.Departments    : sdvc = DepartmentViewController.newInstance()     ; break;
            case SetupType.BusinessAreas  : sdvc = BusinessAreaViewController.newInstance()   ; break;
            case SetupType.CustomConpcept : sdvc = CustomConceptViewController.newInstance()  ; break;

            case SetupType.VAT:
                let vlvc = VATListViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(vlvc);
                break;

            case SetupType.LegalTax         : sdvc = LegalTaxViewController.newInstance()     ; break;
            case SetupType.LegalTaxType     : sdvc = LegalTaxTypeViewController.newInstance() ; break;
            case SetupType.PayMethods       : sdvc = PaymethodListViewController.newInstance(); break;
            case SetupType.PayEntities      : sdvc = PaymentEntityViewController.newInstance(); break;
            case SetupType.BookingsChannels : sdvc = ChannelViewController.newInstance()      ; break;

            case SetupType.Warehouse:
                let wlvc = WarehouseListViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(wlvc);
                break;

            case SetupType.Online:
                let onvc = OnlineSettingsViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(onvc);
                break;

            case SetupType.StockCustomConcept: sdvc = StockCustomConceptViewController.newInstance(); break;

            // case SetupType.StockCategory:
            //     sdvc = StockCategoryViewController.newInstance();
            //     break;

            case SetupType.BookingsZones: sdvc = BookingsZonesSetupViewController.newInstance(); break;
            case SetupType.ProductSource: sdvc = ProductSourceSetupViewController.newInstance(); break;
            case SetupType.Format: sdvc = SettingsFormatViewController.newInstance(); break;
            case SetupType.Tags: sdvc = TagsConfigurationViewController.newInstance(); break;
            case SetupType.AttributeType:
                let atvc = AttributeTypeViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(atvc);
                break;

            // case SetupType.BookingsZonesDays:
            //     sdvc = new BookingsZonesDaySetupViewController("bookings-zones-day-setup-view");
            //     sdvc.initWithResource('layout/bookings/zones/BookingsZonesDaySetupView.html');
            //     break;

            case SetupType.BookingsZonesSetup: sdvc = BookingZoneSetupViewController.newInstance(); break;
            case SetupType.TimeRangePreset:
                let trpvc = TimeRangePresetListViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(trpvc);
                break;

            case SetupType.BookingsRecommendation: sdvc = BookingRecommendationViewController.newInstance(); break;
            case SetupType.CommunicationTemplate: sdvc = CommunicationTemplateViewController.newInstance(); break;
            case SetupType.ScheduledReports:
                let srlvc = ScheduledReportListViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(srlvc);
                break;
            case SetupType.SerialSequence: sdvc = SerialSequenceViewController.newInstance(); break;
            case SetupType.AccountSequence: sdvc = AccountSerialSequenceViewController.newInstance(); break;
            case SetupType.Licenses: sdvc = LicensesDetailViewController.newInstance(); break;
            case SetupType.ElaborationCenter: sdvc = ElaborationCenterSetupViewController.newInstance(); break;
            case SetupType.KitchenOrder: sdvc = KitchenOrderSetupViewController.newInstance(); break;
            case SetupType.Changelog: sdvc = ChangelogViewController.newInstance(); break;
            case SetupType.LedgerAccount: sdvc = LedgerAccountViewController.newInstance(); break;
            case SetupType.AnalyticAccount: sdvc = AnalyticAccountViewController.newInstance(); break;
            case SetupType.QRLocationType: sdvc = QRLocationViewController.newInstance(); break;
            case SetupType.WineCellar: sdvc = WineCellarConfigViewController.newInstance(); break;

            case SetupType.ProductAttributeType:
                let patcvc = ProductAttributeTypeConfigViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(patcvc);
                break;

            case SetupType.StockCategory:
                let sccvc = StockCategoryConfigViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(sccvc);
                break;

            case SetupType.ServiceStatus: sdvc = ServiceStatusViewController.newInstance(); break;
            case SetupType.EmployeeCompensationConcept: sdvc = EmployeeCompensationConceptViewController.newInstance(); break;

            case SetupType.Integrators:
                let ilvc = IntegratorListViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(ilvc);
                break;

            case SetupType.IntegratorMapping:
                let imlvc = IntegratorMappingListViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(imlvc);
                break;

            case SetupType.BankAccountMapping:
                sdvc = BankAccountMappingViewController.newInstance();
                break;

            case SetupType.AccountingJournalTemplate:
                sdvc = AccountingJournalTemplateViewController.newInstance();
                break;

            case SetupType.PaymentInstallmentTemplates:
                let pitvc = PaymentInstallmentTemplateListViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(pitvc);
                break;

            case SetupType.PaymentFeeTemplates:
                let pftvc = PaymentFeeTemplateListViewController.newInstance();
                sdvc = new MUINavigationController();
                sdvc.initWithRootViewController(pftvc);
                break;
        }

        this.splitViewController.showDetailViewController(sdvc);
    }

    private _showNoItemSelected(){
        this._current = null;
        if(!this.noDetailViewController) {
            this.noDetailViewController = new MUIViewController("setup-no-select-view");
            this.noDetailViewController.initWithResource("layout/setup/SetupNoSelectView.html");
        }
        this.splitViewController.showDetailViewController(this.noDetailViewController);
    }

    private _items = null;
    private get items(){
        if (this._items != null) return this._items;

        this.addItem('COMPANY', SetupType.Company);
        this.addItem('GENERAL', SetupType.Settings);
        if ( ( MUIWebApplication.sharedInstance().delegate as AppDelegate ).dlOptionEnabled ) {
            this.addItem('LICENSE TYPE', SetupType.LicenseType);
            this.addItem('BUSINESS REASON TYPES', SetupType.BusinessReasonType);
            this.addItem('PAYMENT FEE TEMPLATES', SetupType.PaymentFeeTemplates);
        }
        this.addItem('VAT', SetupType.VAT);
        this.addItem('LEGAL TAX', SetupType.LegalTax);
        this.addItem('LEGAL TAX TYPE', SetupType.LegalTaxType);
        this.addItem('LEDGER ACCOUNTS', SetupType.LedgerAccount);
        this.addItem('ANALYTIC ACCOUNTS', SetupType.AnalyticAccount);
        this.addItem('EMPLOYEE COMPENSATION CONCEPTS', SetupType.EmployeeCompensationConcept);
        this.addItem('PAY METHODS', SetupType.PayMethods);
        this.addItem('PAYMENT TEMPLATES', SetupType.PaymentInstallmentTemplates);
        this.addItem('PAYMENT ENTITIES', SetupType.PayEntities);
        //this.addItem('TIME RANGES', SetupType.TimeRanges);
        this.addItem('BUSINESS AREAS', SetupType.BusinessAreas);
        this.addItem('DEPARTMENTS', SetupType.Departments);
        this.addItem('WAREHOUSES', SetupType.Warehouse);
        this.addItem('WINE CELLAR', SetupType.WineCellar);
        this.addItem('PRODUCT ATTRIBUTE TYPE', SetupType.ProductAttributeType);
        this.addItem('STOCK CATEGORY', SetupType.StockCategory);
        this.addItem('CUSTOM CONCEPT', SetupType.CustomConpcept);
        //this.addItem('SCHEDULE MANAGEMENT', SetupType.TimeRangePreset);
        this.addItem('ONLINE', SetupType.Online);
        this.addItem('SERVICE STATUS', SetupType.ServiceStatus);
        this.addItem('PRODUCT SOURCE', SetupType.ProductSource);
        this.addItem('FORMATS', SetupType.Format);
        this.addItem('ELABORATION CENTER', SetupType.ElaborationCenter);
        this.addItem('TAGS', SetupType.Tags);
        this.addItem('ATTRIBUTES', SetupType.AttributeType);
        this.addItem('STOCK CUSTOM CONCEPTS', SetupType.StockCustomConcept);
        // this.addItem('STOCK CATEGORY', SetupType.StockCategory);
        //this.addItem('BOOKING ZONES', SetupType.BookingsZones);
        //this.addItem('BOOKING ZONES PER DAY', SetupType.BookingsZonesDays);
        // this.addItem('SERIAL SEQUENCE', SetupType.SerialSequence);
        this.addItem('BOOKING ZONES SETUP', SetupType.BookingsZonesSetup);
        this.addItem('BOOKING CHANNELS', SetupType.BookingsChannels);
        this.addItem('BOOKING RECOMENDATIONS', SetupType.BookingsRecommendation);
        this.addItem('COMMUNICATION TEMPLATES', SetupType.CommunicationTemplate);
        this.addItem('SCHEDULED REPORTS', SetupType.ScheduledReports);
        this.addItem('NUMBER SERIAL SEQUENCE', SetupType.SerialSequence);
        this.addItem('ACCOUNT NUMBER SERIAL SEQUENCE', SetupType.AccountSequence);
        this.addItem('LICENSES', SetupType.Licenses);
        this.addItem('KITCHEN ORDER', SetupType.KitchenOrder);
        this.addItem('CHANGELOG', SetupType.Changelog);
        this.addItem('QR TABLE URL', SetupType.QRLocationType);
        this.addItem('INTEGRATORS', SetupType.Integrators);
        this.addItem('INTEGRATOR MAPPINGS', SetupType.IntegratorMapping);
        this.addItem('BANK ACCOUNT MAPPINGS', SetupType.BankAccountMapping);
        this.addItem('ACCOUNTING JOURNAL TEMPLATES', SetupType.AccountingJournalTemplate);
        this.addItem('TAX REGIME TYPE', SetupType.TaxRegimeType);
        this.addItem('DOCUMENT CATEGORIZATION', SetupType.DocumentCategorization);
        this.addItem('PRODUCT CLASSIFICATION', SetupType.ProductClassification);

        return this._items;
    }

    private addItem(name:string, type, section?){
        if (this._items == null) this._items = [];

        let item = {};
        item["name"] = name;
        item["type"] = type;
        if (section != null) item["section"] = section;

        this._items.push(item);
    }

}
